import React from 'react'
import '../Common.scss';
import defaultImage from '../../../assets/default.png';


export default function FalseCeilingReflectedView({pageDetails}) {
  const {images,metaData}=pageDetails
  let lightsArrays = [];
  let lightKeys= []
  if(metaData.lights.length>0){
    lightKeys=Object.keys(metaData.lights[0])
    let metaDataLights= Array.from(metaData.lights);
  
    let parts=metaData.lights.length/5
    
    for (let i = parts; i > 0; i--) {
      lightsArrays.push(metaDataLights.splice(0, Math.ceil(metaDataLights.length / i)));
    }
  }

  return (
    <React.Fragment>
    <div className="page-image-container">
        <div className="page-heading">{pageDetails?.name}</div>
        <div className="image-section-container">
            <img crossOrigin="anonymous" src={images ? images[0].imageUrl : defaultImage} alt="" className="image-view" />
        </div>
    </div>
    <div style={{ display: "flex" }}>
    {
        metaData?.type ?
          <div className="details-table">
            <div className="details-heading-wrapper details-heading">
              FALSE CEILING TYPE
            </div>
            <div className="details">
              <div className="details-table">
                <div className="table-row" style={{ width: "150px", marginRight: "10px" }}>
                  <div className="table-cell" style={{ width: "20%", fontWeight: '600' }}>
                    Type
                  </div>
                  <div className="table-cell" style={{ width: "80%" }}>
                    {metaData?.type}
                  </div>
                </div>
              </div>
            </div>
          </div> : ''
      }
    {lightsArrays.length>0 ? 
    <div>
      <div className="details-heading-wrapper details-heading">
        LIGHT SPECIFICATIONS
      </div>
      <div className="details">
      {lightsArrays.map((lightsArray,index1)=>{
      return <div className="details-table"  style={{marginRight:"150px"}}  key={index1}>
              <React.Fragment>
                  <div className="table-row" style={{width:"300px"}}>
                      {
                        lightKeys.map((heading,index2)=>{
                            let nameWidth=heading==="name" ? "400%" : "60%"
                            return <div className="table-cell color-heading" key={index2} style={{width:nameWidth}}>
                                {heading.toString().toUpperCase()}
                            </div>
                        })
                      }
                  </div>
              </React.Fragment> 
              {lightsArray.map((arrObj, index) => {
                return (
                    <React.Fragment key={index}>
                        {
                          <div className="table-row" style={{width:"300px",marginRight:"10px"}}>
                              <div className="table-cell" style={{width:"400%"}}>
                                  {arrObj.name}
                              </div>
                              <div className="table-cell" style={{width:"60%"}}>
                                 <div style={{backgroundColor:arrObj.color,border:"1px solid black", width:"90%",height:"10px"}}></div>
                              </div>
                              <div className="table-cell" style={{width:"60%"}}>
                                  {arrObj.quantity}
                              </div>
                              <div className="table-cell" style={{width:"60%"}}>
                                  {arrObj.wattage ? arrObj.wattage : "NA"}
                              </div>
                              <div className="table-cell" style={{width:"60%"}}>
                                  {arrObj.uom ? arrObj.uom : "NA"}
                              </div>
                          </div>
                        }
                    </React.Fragment>
                );
            })}
          </div>
        })}
        </div>
    </div> : null}
    </div>
    </React.Fragment>
  )
}
